import { render } from "./ServicePage.vue?vue&type=template&id=ec3e13ee"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"

import "./ServicePage.vue?vue&type=style&index=0&id=ec3e13ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__